// extracted by mini-css-extract-plugin
module.exports = {"play-button-wrapper":"PlayButton_play-button-wrapper__vSzrj","visually-hidden":"PlayButton_visually-hidden__jzsov","tooltip":"PlayButton_tooltip__5saEA"};